/* eslint-disable @typescript-eslint/naming-convention */
import { ErrorHandler, inject, Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';

import { Observable, throwError, catchError } from 'rxjs';
import { TsSnackbarService } from 'tsui';

const ERROR_MESSAGES = {
  404: 'The page/asset you are looking for does not exist.',
  504: 'The server is taking too long to respond. Please try again later.',
};

const PARCELED_URL_PREFIX = 'https://www.parceled.com';

@Injectable()
export class ErrorHandleInterceptor implements HttpInterceptor {
  private readonly errorHandler = inject(ErrorHandler);
  private readonly snackBar = inject(TsSnackbarService);

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((error) => {
        // [SC-57537] Report 504s to Rollbar instead of showing a snackbar for Parceled requests
        if (error?.status === 504 && req.url?.startsWith(PARCELED_URL_PREFIX)) {
          this.errorHandler.handleError(error);
          return throwError(() => error);
        }

        if (error.status === 404 || error.status === 504) {
          this.snackBar.open(ERROR_MESSAGES[error.status], 'error');
        }

        return throwError(() => error);
      }),
    );
  }
}
